import { Divider, Text } from "@ui-kitten/components";
import React from "react";
import { StyleSheet, View } from "react-native";
import { MixerFlavor, MixerResult } from "../../mixer/useMixer";

interface TableProps {
    result: MixerResult;
}

interface HeaderCellProps {
    children: string | string[];
    style?: any;
    small?: boolean;
}

const HeaderCell: React.FC<HeaderCellProps> = ({ children, style = {}, small = false }) => (
    <View style={[styles.headerCell, style]}>
        <Text category={small ? "c2" : "p1"} appearance="hint">
            {children}
        </Text>
    </View>
);

export const Tr = ({ children }: { children: React.ReactNode }) => <View style={styles.tr}>{children}</View>;

export const RowHeader = ({ children }: { children: string | string[] }) => (
    <View style={styles.rowHeader}>
        <HeaderCell>{children}</HeaderCell>
    </View>
);

export const Cell = ({ children }: { children: string | string[] | number }) => (
    <View style={styles.cell}>
        <Text>{children}</Text>
    </View>
);

export const TBody = ({ children }: { children: React.ReactNode }) => <View style={styles.tbody}>{children}</View>;

const getFlavorG = (data: MixerFlavor[], item: MixerFlavor): number | undefined => {
    const flavor = data.find((f) => f.value === item.value);
    if (flavor) {
        return +flavor.value.toFixed(2);
    }
};

interface FlavorRowProps {
    data: MixerFlavor[];
    flavor: MixerFlavor;
}

const FlavorRow: React.FC<FlavorRowProps> = ({ data, flavor }) => {
    return (
        <>
            <Tr>
                <RowHeader>{flavor.name}</RowHeader>
                <Cell>{flavor.value.toFixed(2)}</Cell>
                <Cell>{!!data && !!flavor && getFlavorG(data, flavor)!.toString()}</Cell>
            </Tr>
            <Divider />
        </>
    );
};

export const Table: React.FC<TableProps> = ({ result }) => {
    return (
        <View style={styles.container}>
            <View style={styles.tableHeaderHorizontal}>
                <HeaderCell style={{ flex: 3 }}>Add</HeaderCell>
                <HeaderCell>ml</HeaderCell>
                <HeaderCell>g</HeaderCell>
            </View>
            <Divider />
            <TBody>
                <Tr>
                    <RowHeader>Nic Base</RowHeader>
                    <Cell>{result.ml.nicBase.toFixed(2)}</Cell>
                    <Cell>{result.g.nicBase.toFixed(2)}</Cell>
                </Tr>
                <Divider />
                {result.ml.flavors.map((flavor) => FlavorRow({ data: result.ml.flavors, flavor }))}
                <Divider />
                <Tr>
                    <RowHeader>VG</RowHeader>
                    <Cell>{result.ml.vg.toFixed(2)}</Cell>
                    <Cell>{result.g.vg.toFixed(2)}</Cell>
                </Tr>
                <Divider />
                <Tr>
                    <RowHeader>PG</RowHeader>
                    <Cell>{result.ml.pg.toFixed(2)}</Cell>
                    <Cell>{result.g.pg.toFixed(2)}</Cell>
                </Tr>
            </TBody>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    tableHeaderHorizontal: {
        flexDirection: "row",
        marginBottom: 16,
    },
    headerCell: {
        alignItems: "flex-start",
        flex: 1,
        margin: 1,
    },
    tr: {
        flexDirection: "row",
        height: 44,
        alignItems: "center",
    },
    rowHeader: {
        flex: 3,
    },
    cell: {
        flex: 1,
    },
    tbody: {},
});
